export default class BaseService {

    constructor(apiBaseUrl = "https://messaging-bot.iot.freeutg.com/api") {
        this.apiBaseUrl = apiBaseUrl;
    }


}